<template>
    <div
        :class="prefixCls + '-head'"
        :style="{
            width: headerWidth,
        }"
    >
        <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            style="table-layout: fixed"
            :style="{
                width: this.cloumnWidth,
            }"
        >
            <colgroup>
                <col
                    v-for="(col, i) in endColumns"
                    :key="col.key || i"
                    :width="col.width"
                />
                <col
                    v-if="showVerticalScrollBar"
                    :width="scrollBarWidth"
                />
            </colgroup>
            <thead>
                <tr v-for="(floor, i) in stackColumns" :key="i">
                    <th
                        v-for="(col, j) in floor"
                        :key="j"
                        :class="[
                            prefixCls + '-th',
                            {
                                'with-border': stackColumns.length > 1,
                            },
                        ]"
                        :style="{
                            height: col._rowspan * 40 + 'px',
                            visibility:
                                col.fixed == location ? 'visible' : 'hidden',
                        }"
                        :align="col.align || 'center'"
                        :rowspan="col._rowspan"
                        :colspan="col._colspan"
                    >
                        {{ col.title }}
                        <!-- 层级展开按钮 -->
                        <div
                            v-if="treeRoot.showExpandLevel && col.indent"
                            :class="prefixCls + '-head-expand'"
                        >
                            <div
                                v-for="i in treeRoot.maxLevel + 1"
                                :class="[
                                    prefixCls + '-head-expand-item',
                                    {
                                        'is-active':
                                            treeRoot.currentExpandLevel ==
                                            i - 1,
                                    },
                                ]"
                                @click.stop="handleExpand(i)"
                            >
                                {{ i }}
                            </div>
                        </div>
                    </th>
                    <th v-if="showVerticalScrollBar"></th>
                </tr>
            </thead>
        </table>
    </div>
</template>
<script>
export default {
    name: 'TreeTableHead',
    inject: ['treeRoot'],
    props: {
        width: {
            type: Number,
            default: 0,
        },
        location: {
            type: String,
            default: 'middle',
            validator: (val) => ['left', 'middle', 'right'].indexOf(val) >= 0,
        },
        columns: {
            type: Array,
            default: function () {
                return []
            },
        },
        showVerticalScrollBar: {
            type: Boolean,
            default: false,
        },
        scrollBarWidth: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            prefixCls: 'ivu-tree-table',
        }
    },
    computed: {
        endColumns() {
            return this.columns.filter((c) => c._isEnd)
        },
        cloumnWidth() {
            return (
                this.endColumns.reduce(
                    (w, col) => w + col.width,
                    this.showVerticalScrollBar ? this.scrollBarWidth : 0
                ) + 'px'
            )
        },
        headerWidth() {
            return this.width ? this.width + 'px' : this.cloumnWidth
        },
        stackColumns() {
            var stacks = []

            this.columns.forEach((col) => {
                if (stacks[col._level]) {
                    stacks[col._level].push(col)
                } else {
                    stacks[col._level] = [col]
                }
            })

            return stacks
        },
    },
    methods: {
        handleExpand(i) {
            this.treeRoot.setExpandLevel(i - 1)
        },
    },
}
</script>
